export class SummaryReceiptModel {
    public totalReceipt!: number;
    public totalExportedWeight!: number;
    public totalExportedVolume !: number;
    public totalExportedAmount!: number;
    public totalUnExportedWeight!: number;
    public totalUnExportedVolume !: number;
    public totalUnExportedAmount!: number;
}